<template>
  <div class="detail-contain" ref="detailContain">
    <!--主体部分-->
    <div class="detail-body" ref="detailBody">
      <!--轮播图-->
      <div class="banner-box">
        <div class="back-icon-box" @click="goBack">
          <i class="iconfont icon-fanhui1 go-back-icon"></i>
        </div>
        <div class="header-btn">
          <span class="btn-box" @click="gotoHome"><i class="iconfont icon-icon_home"></i></span>
          <span class="btn-box" @click="generateImage"><i class="iconfont icon-fenxiang"></i></span>
        </div>
        <van-swipe :autoplay="13000" indicator-color="#45C5DA">
          <van-swipe-item v-for="(slide, key) in bannerList" :key="key">
            <div style="width:100vw;height:100vw;" ref="bannerImage">
              <!-- <img v-bind:src="slide.picUrl" class="banner-img" alt=""> -->
            </div>
            
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="price-share">
        <!--价格-->
        <goodsPrice :price="goodsDetail.price" class="goods-price"></goodsPrice>
        <!--<div class="share-btn">
          <i class="iconfont icon-fenxiang1"></i>
          分享
        </div>-->
      </div>
      <!--商品名称,详情-->
      <div class="goods-name over2line">
        <span>{{ goodsDetail.name }}</span>
      </div>
      <!--商品介绍-->
      <div class="goods-intro">
        <span>{{goodsDetail.intro}}</span>
      </div>
      <!--分割线-->
      <div class="detail_gap"></div>
      <!--已选规格-->
      <div class="select-standard-box" v-show="selectedStandardName">
        <div class="select-standard" @click="openSelectStandard(0)">
          <span class="has-select">已选</span>
          <span class="selected-standard">{{ selectedStandardName }}</span>
        </div>
      </div>
      <!--分割线-->
      <div class="detail_gap"></div>
      <!--评价-->
      <div class="evaluation-box">
        <div class="evalution-title">
          <span class="title-word">用户评价</span>
          <span class="see-more" @click="seeMoreEvaluate">
            查看更多
            <van-icon name="arrow" class="see-more-btn" />
          </span>
        </div>
        <!-- 评价列表 -->
        <div class="no-evaluate" v-show="evaluateList.length === 0">
          暂无评价
        </div>
        <div class="evaluate-list" v-show="evaluateList.length > 0">
          <goods-evaluation :evaluate-list="evaluateList" ></goods-evaluation>
        </div>
      </div>
      <!--分割线-->
      <div class="detail_gap"></div>
      <!-- 商品详情 -->
      <van-tabs v-model="detailActive" color="#45C5DA" :line-height="1" title-active-color="#45C5DA" @change="changeDetailTab">
        <van-tab title="商品详情" name="0">
          <div class="goods-detail detail-standard" v-html="content"></div>
        </van-tab>
        <van-tab title="规格参数" name="1">
          <div class="detail-standard goods-parameter">
            <div v-for="item in attributeList" class="attribute-box">
              <div class="attribute-box-left">{{item.key}}</div>
              <div class="attribute-box-right">{{item.value}}</div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <!--底部按钮-->
    <div class="bottom-btn" ref="bottomBtn">
      <div class="left-btn">
        <div class="service" @click='showServicePhone'>
          <i class="iconfont icon-kefu"></i>
          <div>客服</div>
        </div>
        <div class="shopping-cart" @click="gotoCart">
          <i class="iconfont icon-cart shop-icon">
            <span class="shop-cart-count">{{ cartCount }}</span>
          </i>
          <div>购物车</div>
        </div>
      </div>
      <div class="add-shopping-cart" @click="openSelectStandard(1)">加入购物车</div>
      <div class="buy-btn" @click="openSelectStandard(2)">立即购买</div>
    </div>
    <!--选择规格-->
    <selectStandard
      :ifshow.sync="display.selectStandard"
      :goods-detail="goodsDetail"
      :btn-type="btnType"
      :distribution-user="distributionUser"
      @addCartSuccess="addCartSuccess"
      @select-standard="handleSelectStandard"
    ></selectStandard>
    <!--分享图片-->
    <van-dialog
      class="share-dialog"
      v-model="display.showDialog"
      :show-cancel-button="false"
      :show-confirm-button="false"
      close-on-click-overlay
    >
      <div class="share-image">
        <van-loading type="spinner" color="#45C5DA"  class="image-loading" v-show="!resultImage" />
        <img v-bind:src="resultImage" crossOrigin="anonymous" alt="">
      </div>
      <div class="btn-box">
        <div class="btn" @click="promptShare">分享朋友圈（长按图片保存）</div>
      </div>
    </van-dialog>
    <div class="share-dialog hide-init-image">
      <div class="share-content" id="share-content">
        <div>
          <!-- 分享人信息 -->
          <div class='share-user-info'>
            <!-- 头像 -->
            <div class='user-info-image'>
              <img :src="userInfo.headimgurl" class='info-head-image' alt="">
            </div>
            <!-- 名称 -->
            <div class='info-name-box'>
              <div>
                {{userInfo.nickname}}
              </div>
              <div class='share-user-tips'>
                给你推荐了一个好东西
              </div>
            </div>
          </div>
          <div class="image-box">
            <!-- 增加随机数，防止在本地读取图片缓存导致跨域 -->
            <img v-bind:src="goodsPicture+'?ram='+Math.random()" crossOrigin="Anonymous" class="shart-image">
          </div>
          <div class="goods-name overline">
            <span>{{ goodsDetail.name }}</span>
          </div>
          <goodsPrice :price="goodsDetail.price" class="goods-price"></goodsPrice>
          <div class="qrcode-image">
            <img v-bind:src="QRcode+'?ram='+Math.random()" crossOrigin="Anonymous" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="share-tip-box" @click="hideShareTip" v-show="display.shareTip">
      <div class="share-tip-image">
        <div>
          <i class="iconfont icon-arrow_UP share-top-icon" ></i>
        </div>
        <div>点击"..."</div>
        <div>分享好友</div>
      </div>
    </div>
    
    <van-action-sheet cancel-text="取消" v-model="display.servicePhone" :actions="actions" @select="selectTip" />
  </div>
</template>

<script>
import api from 'api/goods-list';
import userApi from 'api/user';
import selectStandard from 'components/select-standard';
import goodsEvaluation from 'components/goods-evaluation';
import { getWxSign } from 'common/js/getSDKSign';
import html2canvas from 'html2canvas';
import { getToken, gotoOAuth } from 'common/js/ovoSystem';
import wx from 'weixin-js-sdk';
import { mapState } from 'vuex';
export default {
  components: {
    selectStandard,
    goodsEvaluation
  },
  data() {
    return {
      display: {
        selectStandard: false,
        selectAddress: false,
        showDialog: false,
        shareTip: false,
        servicePhone: false, //客服电话菜单
      },
      page:{
        pageSize:5,
        pageNumber:1,
        total:0
      },
      bannerList: [],
      goodsDetail: {},
      selectedNum: 1, //选择的数量
      selectedStandard: {}, //已选的规格
      btnType: 0, //选择规格时下方按钮的类型 0：加入购物车/购买 1：确定（加入购物车） 2：确定（立即购买）
      cartCount: 0, //购物车数量
      ifFromHome:false, //是否从首页轮播图跳转来的
      resultImage:'',//生成的分享的图片
      QRcode:'', //商品链接二维码
      distributionUser:'',//分销员id
      evaluateList: [], //评价列表
      goodsId:'',
      detailActive: 0,
      content:'',//详情
      attributeList: [],//参数列表
      fromPage:'',//是从哪个页面跳转来的
      goodsPictureBase64: '',//商品第一张图片,用于分享
      // selectedStandardName: '',//已选规格名称
      servicePhone: '',
      actions: []
    };
  },
  computed: {
    selectedStandardName() {
      const name = this.selectedStandard.specificationsNames;
      //选择规格时selectedStandard里会添加数量字段，此时数量用这个，如果是第一次进入，则使用默认值1
      const num = this.selectedStandard.selectedNum != undefined ? this.selectedStandard.selectedNum:this.selectedNum;
      return `${name?name+',':''}${num}个`;
    },
    //商品第一张图片
    goodsPicture(){
      if (this.goodsDetail.goodsBannerList && this.goodsDetail.goodsBannerList.length > 0) {
        return this.goodsDetail.goodsBannerList[0].picUrl
      }else{
        return ''
      }
    },
    ifbingphone() { //是否绑定手机号，有涉及用户信息的操作时如果没有绑定则需要去绑定
      return this.$store.state.ifBindPhone
    },
    ...mapState(['userInfo'])
  },
  created() {
    console.log(this.userInfo)
    this.goodsId = this.$route.query.goodsId;
    //是否从首页进入，用于返回首页
    if (this.$route.query.from) {
      this.fromPage = this.$route.query.from;
    }
    //如果有分销员信息，则需传到购买页面传到后台
    if (this.$route.query.distributeId) {
      this.distributionUser = this.$route.query.distributeId;
    }
    //获取数据详情
    this.getGoodsDetail();
    //获取购物车
    this.addCartSuccess();
    //获取评价
    this.getEvaluation();
    //生成商品二维码
    let id = localStorage.getItem('userId_wdsx');
    api.getGoodsCode(`${window.location.href}&distributeId=${id}`)
    .then(res=>{
      this.QRcode = res;
    })

  },
  mounted(){
    const bottomHeight = this.$refs['bottomBtn'].offsetHeight;
    this.$refs['detailContain'].style.height = window.innerHeight + 'px';
    this.$refs['detailBody'].style.height = window.innerHeight - bottomHeight + 'px';
  },
  methods: {
    //回到首页
    gotoHome() {
      this.$router.push({
        name: 'home',
      });
    },
    //生成图片
    async generateImage(){
      //未登录注册
      if (!getToken()) {
        //没有登陆过就跳转鉴权页
        let ua = navigator.userAgent.toLowerCase();//获取判断用的对象
        if (ua.match(/MicroMessenger/i) === "micromessenger" || (Array.isArray(ua.match(/MicroMessenger/i)) && ua.match(/MicroMessenger/i)[0] === "micromessenger")) {
          //在微信中打开
          gotoOAuth()
          return
        }else{
          alert('请使用微信访问此网站')
          return
        }
      }
      if (!this.ifbingphone) {
        this.$router.push({
          name: 'bindphone'
        })
        return
      }
      this.display.showDialog = true;
      var node = document.getElementById('share-content');
      html2canvas(node,{
        useCORS: true
      }).then(canvas=> {
        var dataURL = canvas.toDataURL("image/png");
        this.resultImage = dataURL;
        this.$forceUpdate()
      }).catch(res=>{
        console.log(res);
      });
    },
    goBack() {
      //根据路由的name属性
      if (this.fromPage) {
        this.$router.push({
          name:this.fromPage
        })
      }else{
        this.$router.push({
          path: '/goods-list',
          query: { goodsType: localStorage.getItem('goodsType') },
        });
      }
    },
    //获取数据详情
    async getGoodsDetail() {
      const _this = this;
      const data = await api.getGoodsById({ id: this.goodsId });
      this.goodsDetail = data;
      this.bannerList = this.goodsDetail.goodsBannerList;
      //把轮播图第一张图片作为分享的图片
      /*if (this.goodsDetail.goodsBannerList) {
        getUrlBase64(this.goodsDetail.goodsBannerList[0].picUrl, res=>{
          _this.goodsPictureBase64 = res;
        })
      }*/
      this.$nextTick(() => {
        this.$refs['bannerImage'].map((item, index) => {
          item.style.backgroundImage = `url(${this.bannerList[index].picUrl})`;
          item.style.backgroundSize = `contain`;
          item.style.backgroundRepeat = `no-repeat`;
          item.style.backgroundPosition = `center`;
        })
      })
      
      this.selectedStandard = this.goodsDetail.goodsProductList[0]?this.goodsDetail.goodsProductList[0]:{};
      //如果库存为0
      if (this.selectedStandard.num === 0) this.selectedNum = 0;
      this.content = this.goodsDetail.goodsDetail.detail;
      this.attributeList = this.goodsDetail.goodsAttributeVoList;
      let that = this;
      //获取签名并初始化jssdk
      getWxSign(function () {
        const config = {
          title: that.goodsDetail.name, // 分享标题
          desc: that.goodsDetail.intro, // 分享描述
          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: that.goodsPicture, // 分享图标
          success: function () {
            console.log('设置i成功');
          }
        }
        wx.onMenuShareAppMessage(config);
        wx.onMenuShareTimeline(config);
      })
    },
    //获取评论
    async getEvaluation() {
      const data = await api.getEvaluateByGoodsId({
        goodsId: this.goodsId,
        pageNumber: 1,
        pageSize: 1
      })
      this.evaluateList = data.records;
      this.page.total = data.total;
      console.log(data);
    },
    changePage(page) {
      console.log(page);
      this.page.pageNumber = page;
      this.getEvaluation()
    },

    //打开选择规格组件（加入购物车）
    openSelectStandard(type) {
      this.display.selectStandard = true;
      this.btnType = type;
    },
    //选择规格
    handleSelectStandard(data) {
      this.selectedStandard = data;
    },
    //打开收货地址选择组件
    openSelectAddress() {
      this.display.selectAddress = true;
    },
    //购物车添加成功
    async addCartSuccess() {
      const data = await userApi.getCartNum();
      this.cartCount = data;
    },
    //前往购物车
    gotoCart() {
      this.$router.push({
        name: 'shopCart',
      });
    },
    //提示分享
    promptShare(){
      this.display.showDialog = false;
      this.display.shareTip = true;
    },
    //关闭分享提示
    hideShareTip(){
      this.display.shareTip = false;
    },
    //查看更多评论
    seeMoreEvaluate(){
      this.$router.push({
        path:'evaluate-list',
        query:{
          goodsId: this.goodsId
        }
      })
    },
    //切换详情tab
    changeDetailTab(){

    },
    //显示商品客服信息
    showServicePhone() {
      api.getSupplierTelePhone(this.goodsId)
        .then(res => {
          this.servicePhone = res;
          this.actions = [{name: `客服电话：${res}`}]
        })
      this.display.servicePhone = true;
    },
    //点击客服电话
    selectTip(item) {
      window.location.href = `tel://${this.servicePhone}`
    }
  },
};
</script>

<style lang="scss">
  .detail-contain{
    .goods-detail{
      width: 100%;
      overflow: auto;
      img{
        display: inline-block;
        width: 100%;
        height: auto;
      }
    }
  }
</style>
<style scoped lang="scss">
@import 'common/sass/theme.scss';
.detail-contain {
  position: relative;
  width: 100vw;
  .detail-body {
    padding-bottom: 50px;
    overflow: auto;
    .back-icon-box {
      position: absolute;
      top: 5px;
      left: 5px;
      width: 28px;
      height: 28px;
      line-height: 28px;
      border-radius: 50%;
      background: #7d7d7d;
      color: #fff;
      text-align: center;
      z-index: 99;
      .go-back-icon {
        font-size: 20px;
      }
    }
    .banner-box{
      position: relative;
      width: 100vw;
      height: 100vw;
      .header-btn{
        position: absolute;
        display: flex;
        right: 10px;
        top: 10px;
        z-index: 9;
        .btn-box{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 25px;
          height: 25px;
          margin-left: 5px;
          border-radius: 100%;
          background: #7d7d7d;
          color: #fff;
          line-height: normal;
        }
      }
      .banner-img {
        display: inline-block;
        width: 100vw;
        height: 100vw;
        /*width: 200px;
          height: 200px;*/
      }
    }
    .goods-price {
      display: inline-block;
      margin: 0 10px;
      font-size: 24px;
      font-weight: bold;
    }
    .goods-name {
      margin: 0 10px;
      font-weight: 700;
      margin-bottom: 5px;
      word-wrap: break-word;
    }
    .goods-intro{
      margin: 0 10px;
      color: $light-color;
      font-size: 14px;
    }
    .price-share{
      display: flex;
      justify-content: space-between;
      .share-btn{
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        margin-right: 10px;
        font-size: 12px;
      }
    }
    .detail_gap {
      padding-top: 10px;
      background: #e8e8ed;
      position: relative;
      z-index: 2;
    }
    /*规格选择*/
    .select-standard-box {
      .select-standard {
        position: relative;
        padding: 12px 0 12px 10px;
        font-size: 12px;
        color: $light-color;
        border-bottom: 1px solid $light-line-color;
        .has-select {
          vertical-align: text-top;
        }
        .selected-standard {
          margin: 0 10px;
          color: $weight-word-color;
          font-size: 14px;
          vertical-align: middle;
        }
      }
    }
    //用户评价
    .evaluation-box{
      .evalution-title{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 45px;
        padding: 0 10px;
        border-bottom: 1px solid $light-line-color;
        .see-more{
          font-size: 14px;
        }
        .see-more-btn{
          font-size: 18px;
          vertical-align: sub;
        }
      }
      .no-evaluate{
        padding: 10px 0;
        text-align: center;
        font-size: 14px;
        color: $lingt-word-color;
      }
      .evaluate-list{
      }
    }
    .detail-standard{
      min-height: 80vh;
    }
    .goods-parameter{
      padding: 10px;
      .attribute-box{
        display: flex;
        width: 100%;
        height: 35px;
        line-height: 35px;
        border: 1px solid #ddd;
        font-size: 12px;
        .attribute-box-left{
          width: 30%;
          padding-left: 8px;
          border-right: 1px solid #ddd;
        }
        .attribute-box-right{
          flex: 1;
          padding-left: 8px;
        }
      }
    }
    /*收货地址选择*/
  }
  .bottom-btn {
    display: flex;
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 50px;
    text-align: center;
    color: #fff;
    background: #fff;
    z-index: 90;
    .left-btn {
      display: flex;
      flex: 1;
      color: #999;
      font-size: 13px;
      font-weight: bold;
      border-top: 1px solid #f5f5f5;
      i {
        font-size: 18px;
      }
      .shopping-cart,
      .service {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex: 1;
        .shop-icon {
          position: relative;
          .shop-cart-count {
            position: absolute;
            display: inline-block;
            top: 0;
            left: 10px;
            background: #45c5da;
            padding: 0 4px;
            border-radius: 10px;
            color: #fff;
            font-size: 12px;
            font-weight: normal;
            line-height: normal;
          }
        }
      }
      .service{
        border-right: 1px solid #f5f5f5;
      }
    }
    .add-shopping-cart {
      flex: 1;
      background: #f90;
      line-height: 50px;
    }
    .buy-btn {
      flex: 1;
      background: $theme-color;
      line-height: 50px;
    }
  }
  .share-dialog{
    width: 80vw;
    .share-image{
      position: relative;
      display: inline-block;
      width: 100%;
      height: auto;
      min-height: 300px;
      .image-loading{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50% ,-50%);
      }
      img{
        display: inline-block;
        width: 100%;
        height: 100%;
      }
    }
    .share-content{
      padding: 10px;
      background: #fff;
      .image-box{
        padding: 5px 20px 20px;
        .shart-image{
          display: inline-block;
          width: 100%;
          height: 100%;
          max-height: 100vw;
        }
      }
      .goods-name {
        margin: 10px 0;
        margin-bottom: 5px;
      }
      .qrcode-image{
        width: 120px;
        height: 120px;
        margin: auto;
        img{
          display: inline-block;
          width: 100%;
          height: 100%;
        }
      }
      .result-image{
        display: inline-block;
        width: 100%;
        height: 100%;
      }
      .share-user-info{
        display: flex;
        padding: 0 10px;
        .info-head-image{
          display: inline-block;
          width: 50px;
          height: 50px;
          border-radius: 100%;
          overflow: hidden;
        }
        .info-name-box{
          display: flex;
          flex-direction: column;
          justify-content: center;
          font-size: 15px;
          flex: 1;
          margin-left: 10px;
        }
        .share-user-tips{
          font-size:12px;
          color: #888;
        }
      }
    }
    .btn-box{
      display: flex;
      border-top: 1px solid #ddd;
      height: 40px;
      background: $theme-color;
      color: #fff;
      .btn{
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex: 1;
        box-sizing: border-box;
        &:first-of-type{
          border-right: 1px solid #ddd;
        }
      }
    }
  }
  .share-tip-box{
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1000;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
    .share-tip-image{
      color: #fff;
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,.5);
      /*overflow: hidden;
      background: url('../../assets/arrow-share.png')no-repeat center/cover;*/
      .share-top-icon{
        color: #fff;
        font-size: 25px;
      }
      div{
        text-align: right;
        padding-right: 10px;
      }
    }
  }
  .hide-init-image{
    height: 0;
    overflow: hidden;
  }
}
</style>
